import { ApiService } from "qccat-ui";
import { WebServiceUrl, LoginUrl } from "../config/appUrlConfig";

export const authApiService = new ApiService( { apiUrl: WebServiceUrl, loginUrl: LoginUrl });